export default ({
  data,
  yKeys,
  xKey,
  colorLabel,
  colorTheme,
  height,
  title,
  handleTooltip,
  onClickGraph,
  rotationKey,
  showPercentage,
  yAxis,
  tick,
  paddingTop,
  legend,
  paddingBottom
}) => {
  const fills = yKeys?.map((key) => colorTheme[key] || '#fff')
  return {
    data,
    background: { visible: false },
    title: {
      text: title,
      color: colorLabel,
      fontFamily: 'Montserrat, sans-serif'
    },
    height: height && height,
    series: [
      {
        type: 'column',
        yKeys: yKeys,
        xKey: xKey,
        strokes: 0,
        fills,
        highlightStyle: { fill: colorLabel },
        yNames: yKeys,
        tooltipRenderer: handleTooltip,
        listeners: {
          nodeClick: (param) => (onClickGraph ? onClickGraph(param) : () => {})
        }
      }
    ],
    axes: [
      {
        type: 'category',
        position: 'bottom',
        label: {
          color: colorLabel,
          rotation: rotationKey || 0,
          padding: rotationKey ? 10 : 5
        },
        tick: {
          width: 0
        }
      },
      {
        type: 'number',
        position: 'left',
        label: {
          color: colorLabel,
          formatter:
            showPercentage &&
            function (params) {
              return params.value + '%'
            }
        },
        title: yAxis
          ? {
              text: yAxis,
              color: colorLabel,
              fontFamily: 'Montserrat, sans-serif'
            }
          : null,
        tick: {
          count: tick ? tick.count : 6,
          width: tick ? tick.width : 0
        }
      }
    ],
    padding: {
      top: paddingTop || 0,
      right: 5,
      bottom: paddingBottom || 20,
      left: 5
    },
    legend: {
      enabled: legend,
      color: colorLabel,
      position: 'bottom',
      markerSize: 10,
      fontFamily: 'Montserrat, sans-serif',
      layoutVerticalSpacing: 18
    }
  }
}
